"use client";
import { useEffect, useState } from "react";

export enum DeviceType {
  "mobile",
  "tablet",
  "desktop",
}

function getDeviceType(): DeviceType {
  const width = window.innerWidth;
  const pointer = window.matchMedia("(pointer: fine)").matches
    ? "fine"
    : "coarse";
  const ua = navigator.userAgent.toLowerCase();

  const isTabletUA = /(ipad|tablet|android(?!.*mobile)|silk)/i.test(ua);
  const isMobileUA =
    /(iphone|ipod|android.*mobile|blackberry|windows phone)/i.test(ua);

  if (pointer === "coarse") {
    if (isMobileUA) return DeviceType.mobile;
    if (isTabletUA || width >= 744) return DeviceType.tablet;
  }

  if (pointer === "fine") {
    if (width < 744) return DeviceType.mobile;
    if (width >= 744 && width < 1200) return DeviceType.tablet;
    return DeviceType.desktop;
  }

  return width >= 1200 ? DeviceType.desktop : DeviceType.mobile;
}

export function useDeviceType(): DeviceType {
  const [deviceType, setDeviceType] = useState<DeviceType>(() => {
    // Guard for SSR
    if (typeof window === "undefined") {
      return DeviceType.desktop; // or tablet, your choice
    }
    return getDeviceType();
  });

  useEffect(() => {
    let resizeTimeout: NodeJS.Timeout;

    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        setDeviceType(getDeviceType());
      }, 200);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return deviceType;
}
